import { render } from "./ExpertsPage.vue?vue&type=template&id=4bd4fe02"
import script from "./ExpertsPage.vue?vue&type=script&lang=js"
export * from "./ExpertsPage.vue?vue&type=script&lang=js"

import "./ExpertsPage.vue?vue&type=style&index=0&id=4bd4fe02&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__